import { render, staticRenderFns } from "./ConvenioDeudaCard.vue?vue&type=template&id=526358de&scoped=true"
import script from "./ConvenioDeudaCard.vue?vue&type=script&lang=js"
export * from "./ConvenioDeudaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "526358de",
  null
  
)

export default component.exports